export default class Lead {
    constructor () {

        this.id = null
        this.first_name = ""
        this.surname = ""
        this.company = ""
        this.message = ""
        this.phone = ""
        this.mobile = ""
        this.status = "New"
        this.stage = "enquiry"
        this.lead_type = null
        this.source = null
        this.value = null

        this.user_id = null
    }
}
